import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Variant } from './paragraph';

export const bodyExtraLarge = css`
  font-size: 1.5rem;
  line-height: 2rem;
`;

export const bodyLarge = css`
  font-size: 1.125rem;
  line-height: 1.75rem;
`;

export const bodyMedium = css`
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const bodySmall = css`
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const bodyExtraSmall = css`
  font-size: 0.75rem;
  line-height: 1rem;
`;

export const StyledParagraph = styled.p<{
  variant: Variant;
  accent?: boolean;
  lighter?: boolean;
  semiBold?: boolean;
  bold?: boolean;
}>`
  margin: 0;
  padding: 0;

  ${({ variant }): FlattenSimpleInterpolation | undefined => {
    if (variant === 'extra-large') {
      return bodyExtraLarge;
    }

    if (variant === 'large') {
      return bodyLarge;
    }

    if (variant === 'medium') {
      return bodyMedium;
    }

    if (variant === 'small') {
      return bodySmall;
    }

    if (variant === 'extra-small') {
      return bodyExtraSmall;
    }

    return;
  }}

  ${({ theme, accent, lighter }): { [key: string]: string } => {
    if (accent) {
      return {
        color: theme.palette_blue_100
      };
    }

    // as it has the lowest prioriy `lighter` was moved to the bot
    if (lighter) {
      return {
        color: theme.palette_gray_60
      };
    }

    return {
      color: 'inherit'
    };
  }};

  ${({
    bold = false,
    semiBold = false
  }): FlattenSimpleInterpolation | undefined => {
    if (bold === true) {
      return css`
        font-weight: 700;
      `;
    }

    if (semiBold === true) {
      return css`
        font-weight: 600;
      `;
    }

    return;
  }}
`;
